
/* eslint-disable max-len */
export const shareLocations = {
  facebook: {
    func: (title, location) => `https://facebook.com/sharer/sharer.php?u=${location}`,
    color: '#3b5998',
    svgPath: 'M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z',
  },
  twitter: {
    func: (title, location) => `https://twitter.com/intent/tweet/?text=${title}&url=${location}`,
    color: '#55acee',
    svgPath: 'M8 2H1l8.26 11.015L1.45 22H4.1l6.388-7.349L16 22h7l-8.608-11.478L21.8 2h-2.65l-5.986 6.886zm9 18L5 4h2l12 16z',
  },
  email: {
    func: (title, location) => `mailto:?subject=${title}&body=${location}`,
    color: 'grey',
    svgPath: 'M22 4H2C.9 4 0 4.9 0 6v12c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.25 14.43l-3.5 2c-.08.05-.17.07-.25.07-.17 0-.34-.1-.43-.25-.14-.24-.06-.55.18-.68l3.5-2c.24-.14.55-.06.68.18.14.24.06.55-.18.68zm4.75.07c-.1 0-.2-.03-.27-.08l-8.5-5.5c-.23-.15-.3-.46-.15-.7.15-.22.46-.3.7-.14L12 13.4l8.23-5.32c.23-.15.54-.08.7.15.14.23.07.54-.16.7l-8.5 5.5c-.08.04-.17.07-.27.07zm8.93 1.75c-.1.16-.26.25-.43.25-.08 0-.17-.02-.25-.07l-3.5-2c-.24-.13-.32-.44-.18-.68s.44-.32.68-.18l3.5 2c.24.13.32.44.18.68z',
  },
}
/* eslint-enable max-len */

export const FbIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    style={{ width: '1.2rem'}}
  >
    <path d={shareLocations['facebook'].svgPath} />
  </svg>
)

export const TwitterIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    style={{ width: '1.2rem'}}
  >
    <path d={shareLocations['twitter'].svgPath} />
  </svg>
)

export const EmailIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    style={{ width: '1.2rem'}}
  >
    <path d={shareLocations['email'].svgPath} />
  </svg>
)